const INLINE = /(\*\*[^*\n]+\*\*|\[[^\]\n]+\]\([^)\s]+\)|https?:\/\/[^\s)]+)/g;

const inline = (text) =>
    text
        .split(INLINE)
        .filter((p) => p !== "" && p !== undefined)
        .map((part, i) => {
            if (/^\*\*[^*\n]+\*\*$/.test(part)) {
                return <strong key={i}>{part.slice(2, -2)}</strong>;
            }
            const md = part.match(/^\[([^\]\n]+)\]\(([^)\s]+)\)$/);
            const href = md ? md[2] : /^https?:\/\//.test(part) ? part : null;
            if (href && /^https?:\/\//.test(href)) {
                return (
                    <a
                        key={i}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="font-medium text-accent underline decoration-accent/40 underline-offset-2 break-words"
                    >
                        {md ? md[1] : part}
                    </a>
                );
            }
            return part;
        });

/** Renders a safe subset of markdown: line breaks, bold, bullet lists, links. */
export const RichText = ({ text }) => {
    const blocks = [];
    (text || "").split("\n").forEach((raw) => {
        const line = raw.trimEnd();
        const bullet = line.match(/^\s*(?:[-*•]|\d+[.)])\s+(.*)$/);
        const last = blocks[blocks.length - 1];
        if (bullet) {
            if (last && last.type === "list") last.items.push(bullet[1]);
            else blocks.push({ type: "list", items: [bullet[1]] });
            return;
        }
        if (!line.trim()) {
            if (last && last.type === "text") blocks.push({ type: "gap" });
            return;
        }
        if (last && last.type === "text") last.lines.push(line);
        else blocks.push({ type: "text", lines: [line] });
    });

    return (
        <>
            {blocks.map((b, i) => {
                if (b.type === "gap") return <div key={i} className="h-2" />;
                if (b.type === "list") {
                    return (
                        <ul key={i} className="my-1.5 space-y-1 pl-4">
                            {b.items.map((item, j) => (
                                <li key={j} className="relative list-none">
                                    <span className="absolute -left-3.5 top-[0.55em] h-1.5 w-1.5 rounded-full bg-accent" />
                                    {inline(item)}
                                </li>
                            ))}
                        </ul>
                    );
                }
                return (
                    <p key={i} className="whitespace-pre-wrap">
                        {b.lines.map((line, j) => (
                            <span key={j}>
                                {j > 0 && <br />}
                                {inline(line)}
                            </span>
                        ))}
                    </p>
                );
            })}
        </>
    );
};

export default RichText;
